import { authenService, masterDataService, defaultParams } from 'services'

export const requestOtpApi = ({ phone }) => {
  return authenService({
    method: 'post',
    url: `/request-sms-otp`,
    data: {
      type: ['CUSTOMER'],
      phone,
    },
  })
}

export const verifyOtpApi = ({ token, otp }) => {
  return authenService({
    method: 'post',
    url: `/verify-sms-otp`,
    data: {
      token,
      otp,
    },
  })
}

export const loginWithOtpApi = ({ token, otp }) => {
  return authenService({
    method: 'post',
    url: `/login-sms-otp`,
    data: {
      token,
      otp,
    },
  })
}

export const registerCustomerApi = ({ token, otp, name, surname }) => {
  return authenService({
    method: 'post',
    url: `/register/customer`,
    data: {
      token,
      otp,
      name,
      surname,
    },
  })
}

export const getMe = () => {
  return authenService({
    method: 'get',
    url: `/me`,
    // headers: {
    //   Authorization: `Bearer ${token}`,
    // },
  })
}

export const updateCustomerByStakeholderId = (stakeholderId, data) => {
  return masterDataService({
    method: 'patch',
    url: `/stakeholder/${stakeholderId}`,
    data,
  })
}

export const getCustomerByStakeholderId = stakeholderId => {
  return masterDataService({
    method: 'post',
    url: `/stakeholder/query`,
    data: {
      where: [
        {
          ...defaultParams,
          id: stakeholderId,
          filter: 'all-facilities',
        },
      ],
    },
  })
}
